// Canonical Supabase browser client for Eat This Fast & Fresh Meal Planner.
//
// Phase B1 · Rules:
//   * This is the ONLY module that calls createClient(). All other
//     application code must import { supabase, supabaseConfigured,
//     requireSupabase } from '../lib/supabaseClient' (directly or via
//     the legacy alias in ../lib/supabase.js which re-exports this).
//   * Reads exactly two environment variables:
//        REACT_APP_SUPABASE_URL
//        REACT_APP_SUPABASE_PUBLISHABLE_KEY
//     No service-role key, secret key, JWT secret, or database password
//     is ever referenced from the browser bundle.
//   * When either variable is empty, no client is created; consumers
//     receive supabaseConfigured === false and a null client.  This
//     lets the app render without a network call before the owner has
//     populated /app/frontend/.env locally.

import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL || '';
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '';

export const supabaseConfigured = Boolean(url && publishableKey);

export const supabase = supabaseConfigured
  ? createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export function requireSupabase() {
  if (!supabase) {
    throw new Error(
      'Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY in /app/frontend/.env.'
    );
  }
  return supabase;
}
